import Carousel from "components/Carousel";
import Content from "components/Content";
import Label from "components/Label";
import Media from "components/Media";
import React, { FC } from "react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";

import ProviderReview from "./components/ProviderReview";
import { reviews } from "./consants";
import styles from "./styles.module.scss";

const HearFromOurProviders: FC = () => {
  return (
    <Content
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <Label variant="h2-centered" color="primary">
        Hear from our service providers
      </Label>
      <Media at={["desktop", "tablet"]}>
        <Carousel gradient={false} className={styles.reviews}>
          {reviews.map((review) => (
            <ProviderReview key={review.content} {...review} />
          ))}
        </Carousel>
      </Media>
      <Media className={styles.media} at={["mobile"]}>
        <Swiper navigation modules={[Navigation]} centeredSlides>
          {reviews.map((review) => (
            <SwiperSlide>
              <ProviderReview key={review.content} {...review} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Media>
    </Content>
  );
};

export default HearFromOurProviders;
